import { Injectable } from '@angular/core';
import { LoggerService } from '@nx-fe/services';
import { Enums } from '../../../../../../../../libs/services/enums/enums';
import { SspRestApiService } from '../../../../services/sspRestApiService';
import { LogicFault, ServerError } from '../../../../shared/util/errors';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor(private sspRestApiService: SspRestApiService, private $log: LoggerService) {}

  public actionListener: Subject<any> = new BehaviorSubject<any>(null);

  get actionListener$() {
    return this.actionListener.asObservable();
  }

  executeDeviceAction(deviceAction: Enums.DeviceActions, DeviceId: string, params: any): Promise<any> {
    const logPrefix = 'DeviceSvc: deviceAction(): ';
    this.$log.debug(logPrefix + 'started');

    const arg = name => {
      if (!Object.keys(params).includes(name)) {
        throw new LogicFault('Missing required parameter: ' + name);
      }
      return params[name];
    };

    const chooseAction = deviceActionLocal => {
      switch (deviceActionLocal) {
        case Enums.DeviceActions.Lock:
          return this.sspRestApiService.lockDevice(DeviceId, arg('phone'), arg('message'), arg('password'));
        case Enums.DeviceActions.Wipe:
          return this.sspRestApiService.wipeDevice(DeviceId, arg('password'));
        case Enums.DeviceActions.UnEnroll:
          return this.sspRestApiService.unenrollDevice(DeviceId);
        case Enums.DeviceActions.SendMessage:
          return this.sspRestApiService.sendMessage(DeviceId, arg('message'));
        case Enums.DeviceActions.Locate:
          return this.sspRestApiService.locateDevice(DeviceId);
        case Enums.DeviceActions.ResetPasscode:
          return this.sspRestApiService.setPassword(DeviceId, arg('password'));
        case Enums.DeviceActions.RemovePasscode:
          return this.sspRestApiService.removePassword(DeviceId);
        case Enums.DeviceActions.CheckIn:
          return this.sspRestApiService.checkInDevice(DeviceId);
        default:
          throw new LogicFault('Unknown device action: ' + deviceActionLocal);
      }
    };

    return chooseAction(deviceAction)
      .toPromise()
      .then(
        actionResponse => {
          this.$log.debug(logPrefix + 'action promise resolved', actionResponse);
          return actionResponse;
        },
        reason => {
          this.$log.error(logPrefix + 'action promise rejected', reason);

          const error = new ServerError(reason.data, reason.status);
          // adjust server error with more details
          if (error.is(Enums.ServerErrors.BusinessLogicException) && error.businessLogic.code === 1707) {
            error.addFlag(Enums.ServerErrors.NotSupported);
          }

          return error;
        }
      );
  }
}
